var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"message-input scroll-px-5",attrs:{"tabindex":"1","placeholder":_vm.$t('chat.typeYourMessage'),"rows":"1"},domProps:{"value":_vm.text},on:{"input":function($event){_vm.text = $event.target.value},"enter":_vm.send,"keydown":_vm.handleKeydown,"focus":_vm.markAsReadMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }